import React, { Component } from 'react';
import arrowRight from '../../images/right-arrow.svg';
import arrowLeft from '../../images/left-arrow.svg';

// Used for products which are onkly selectable, not draggable
class SelectProduct extends Component {

	render() {
		return (
			<div className={`selection-item ${this.props.type === 'baseplate' ? 'first': ''}`}>
        <div className="title">
         <h5>{this.props.title}</h5>
        </div>

        <div className="product-type">
          <div className="inner-with-arrows">
            <button className="item arrow-left btn" onClick={() => this.props.renderActiveSelectable('prev', this.props.type)}>
              <img src={arrowLeft} alt="Left" />
            </button>

            <div className="item content">
              {this.props.type === 'baseplate' &&
                <div className="color"style={{backgroundColor: `${this.props.activeBaseplate === 0 ? '#3e5b87' : this.props.activeBaseplate === 1 ? '#1b1b1b' : this.props.activeBaseplate === 2 ? '#959ba7' : '#a29e85'}`}}></div>
              }

              {this.props.type === 'fastening-cord' &&
                <div className={`color 
                  ${
                    this.props.activeCord === 0 ? 'black' : 
                    this.props.activeCord === 1 ? 'neon-pink' :
                    this.props.activeCord === 2 ? 'red-yellow' :
                    this.props.activeCord === 3 ? 'rudi' :
                    this.props.activeCord === 4 ? 'grey-black' :
                    this.props.activeCord === 5 ? 'turquoise' :
                    this.props.activeCord === 6 ? 'purple-black' :
                    this.props.activeCord === 7 ? 'orange' :
                    this.props.activeCord === 8 ? 'ole' :
                    this.props.activeCord === 9 ? 'brunhilde' :
                    this.props.activeCord === 10 ? 'sissi' :
                    this.props.activeCord === 11 ? 'franz' :
                    this.props.activeCord === 12 ? 'lorelei' :
                    this.props.activeCord === 13 ? 'alfons' :
                    this.props.activeCord === 14 ? 'mathilde' :
                    this.props.activeCord === 15 ? 'herbert' :
                    this.props.activeCord === 16 ? 'sibylle' :
                    this.props.activeCord === 17 ? 'paulina' :
                    this.props.activeCord === 18 ? 'dorothea' :
                    this.props.activeCord === 19 ? 'fritz' :
                    this.props.activeCord === 20 ? 'josef' :
                    this.props.activeCord === 21 ? 'hans' :
                    this.props.activeCord === 22 ? 'ester' :
                    'black'
                  }
                `}></div>
              }
            </div>

            <button className="item arrow-right btn" onClick={() => this.props.renderActiveSelectable('next', this.props.type)}>
               <img src={arrowRight} alt="Right" />
            </button>
          </div>
        </div>
			</div>
		)
	}
}
export default SelectProduct;